import type { OrderRecord } from "@/types";

export interface AppFeesTotals {
  /** Total app fee across every app order — always borne by the customer. */
  total: number;
  /** Number of orders created from the customer app. */
  orders: number;
  /** Fixed fee applied to each app order. */
  perOrder: number;
  /** App fee collected electronically for the platform (never deducted from the store). */
  electronic: number;
  electronicOrders: number;
  /** App fee on cash app orders — collected by the store and added to its cash debt. */
  cash: number;
  cashOrders: number;
}

const round2 = (value: number): number => Math.round(value * 100) / 100;

const sumFee = (list: OrderRecord[]): number =>
  round2(list.reduce((sum, order) => sum + order.appFee, 0));

export function computeAppFees(orders: OrderRecord[]): AppFeesTotals {
  const appOrders = orders.filter((order) => order.source === "app");
  const electronicOrders = appOrders.filter((order) => order.payment !== "cash");
  const cashOrders = appOrders.filter((order) => order.payment === "cash");

  const total = sumFee(appOrders);
  const perOrder =
    appOrders.length > 0 ? round2(total / appOrders.length) : 0;

  return {
    total,
    orders: appOrders.length,
    perOrder,
    electronic: sumFee(electronicOrders),
    electronicOrders: electronicOrders.length,
    cash: sumFee(cashOrders),
    cashOrders: cashOrders.length,
  };
}